// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".a2542330a7042bb9ad4e4192394316c0bb65e466.chunk.js";
};